// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import O1HD from "../../../../../engines/gameEngine";
import data_control from "../../../../../engines/libs/data_control";
import LotteryBaseLayer from "../common/LotteryBaseLayer";
import ChengYiItemBase from "./ChengYiItemBase";
import { ChengYiKind } from "./data/ChengYiKind";

const {ccclass, property} = cc._decorator;

@ccclass
export default class ChengYiManManLayer extends LotteryBaseLayer {

	@property({ type: cc.Node, displayName:'' })
	nodeLayoutHint: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeCombinationLayout: cc.Node = null;

    /** 牌型数据 */
    private orangeCount = 0;
    private orangeIdx = 0;

    // onLoad () {}

    start () {
        super.start();

        this.resetData();
    }

    // update (dt) {}

    resetData() {
        super.resetData();

        this.showHint();
        this.getCardTypeData();
        this.resetCombinationArea();
    }

    showHint() {
        let len = ChengYiKind.WinProb.length;
        this.nodeLayoutHint.children.forEach((node, i)=> {
            let idx = len - i - 1;
            let info = ChengYiKind.WinProb[idx];
            let nodeLayout = node.getChildByName('nodeLayout');
            let labelCount = nodeLayout.getChildByName('labelCount').getComponent(cc.Label);
            let labelAward = nodeLayout.getChildByName('labelAward').getComponent(cc.Label);
            labelCount.string = info.count + '个';
            labelAward.string = data_control.getNumberFormat(info.sum);
            let nodeWin = node.getChildByName('nodeWin');
            nodeWin.active = false;
        });
    }

    /**
     * 获得牌型数据
     * @returns 
     */
    getCardTypeData() {
        // 是否必中
        // let bInfallible = false;

        let len = ChengYiKind.WinProb.length;
        let randv = data_control.randomNum(0, 1);
        let prob = 0;
        let orangeCount = 0;
        this.orangeIdx = 1;
        for (let i = 0; i < len; i++) {
            let winPropInfo = ChengYiKind.WinProb[i];
            prob += winPropInfo.prob;

            if (prob >= randv) {
                this.orangeIdx = i;
                if (i==0) {
                    orangeCount = data_control.randomNumInt(1, 2);
                } else {
                    orangeCount = winPropInfo.count;
                }
                break;
            }
        }
        this.orangeCount = orangeCount;

        // cc.log('---- this.orangeCount',this.orangeCount, this.orangeIdx, randv, prob)
    }

    /**
     * 组合区
     */
    resetCombinationArea() {
        // this.nodeCombinationLayout.removeAllChildren();
        let count: boolean[] = new Array(ChengYiKind.GeneralValue.CardCount).fill(false);
        if (this.orangeCount < ChengYiKind.GeneralValue.CardCount) {
            let ret = data_control.randomIntNum(0, 9, this.orangeCount);
            for (let o of ret) {
                count[o] = true;
            }
        } else {
            count = new Array(ChengYiKind.GeneralValue.CardCount).fill(true);
        }

        // cc.log('-- count',count);
        
        this.nodeCombinationLayout.children.forEach((node, i)=> {
            let script = node.getComponent(ChengYiItemBase);
            let bWin = count[i];
            let type = ChengYiKind.CardType.ORANGE;
            if (!bWin) {
                type = data_control.randomNumInt(ChengYiKind.CardType.ORANGE+1, ChengYiKind.CardType.Max-1);
            }
            script.resetData();
            script.setData(type);
        });
    }

    checkJudge(pos1: cc.Vec2, pos2: cc.Vec2) {
        this.checkJudgeLottery(pos1, pos2);
    }

    checkJudgeNode(pos: cc.Vec2) {
        this.checkJudgeLottery(pos);
    }

    showAward() {
        if (this.orangeIdx == 0) {
            return;
        }
        let winInfo = ChengYiKind.WinProb[this.orangeIdx];
        let len = ChengYiKind.WinProb.length;
        let idx = len - this.orangeIdx - 1;
        let nodeItem = this.nodeLayoutHint.children[idx];
        if (!nodeItem) {
            console.error('获取错误 idx = ' + idx);
            return;
        }
        let nodeWin = nodeItem.getChildByName('nodeWin');
        nodeWin.active = true;
        O1HD.getManagers().soundMgr.playSound("gglAddCoins").then();
        O1HD.getServices().userSrv.setCoins(winInfo.sum, true , nodeItem);
    }

    checkJudgeLottery(pos1: cc.Vec2, pos2: cc.Vec2 = null) {
        if (this.bFinishShow) {
            return;
        }

        let childrenCom = this.nodeCombinationLayout.children;
        let lenCom = childrenCom.length;
        for (let i = 0; i < childrenCom.length; i++) {
            let childNode = childrenCom[i];
            let script = childNode.getComponent(ChengYiItemBase);
            if (script.isOpenShow()) {
                lenCom--;
            } else {
                if (pos2) {
                    if (script.checkJudge(pos1, pos2)) {
                        lenCom--;
                    }
                } else {
                    if (script.checkJudgeNode(pos1)) {
                        lenCom--;
                    }
                }
            }
        }

        if (lenCom <= 0) {
            this.bFinishShow = true;
            this.showAllMask();
            this.showAward();
        }   
    }
}
